import "gsap/dist/gsap.min.js";
import "gsap/ScrollTrigger.js";
import "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollTrigger);

export default class ScrollFunction {
  constructor() {
    // window.addEventListener("resize", () => this.resize());
    this.scrollControl();
  }
  // init() {
  //   this.scrollControl();
  // }
  scrollControl() {
    let mobileSections = gsap.utils.toArray(".page-section");
    let bgs = document.querySelectorAll("[js-mobile-scrollcontrol]");
    bgs.forEach(function (bgs, i) {
      ScrollTrigger.create({
        trigger: mobileSections[i],
        start: "top 50%",
        end: "bottom 0%",
        toggleClass: { targets: bgs, className: "triggerfade" },
        // markers: true,
      });
    });
    let texts = document.querySelectorAll("[js-mobile-scrollcontrol-text]");
    texts.forEach(function (texts, i) {
      ScrollTrigger.create({
        trigger: mobileSections[i],
        start: "top 100%",
        end: "bottom 10%",
        toggleClass: { targets: texts, className: "triggerfade" },
        // markers: true,
      });
    });

    //mobile contact us section
    let contact = document.querySelector(".contactus");
    let contactContent = document.querySelector(".contactus--top");
    ScrollTrigger.create({
      trigger: contact,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: contactContent, className: "triggerCt" },
      // markers: true,
    });

    // mobile patronship section
    let triggerPatronship = document.querySelector(".patronship--mobile");
    ScrollTrigger.create({
      trigger: triggerPatronship,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerPatronship, className: "triggerPs" },
      // markers: true,
    });

    // mobile book a visit section
    let triggerBookAVist = document.querySelector(".bookavisit--mobile");
    ScrollTrigger.create({
      trigger: triggerBookAVist,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerBookAVist, className: "triggerVist" },
      // markers: true,
    });

    // mobile booking section

    let triggerbooking = document.querySelector(".booking--mobile");
    ScrollTrigger.create({
      trigger: triggerbooking,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerbooking, className: "triggerPs" },
      // markers: true,
    });

    // mobile events
    let triggerEvent = document.querySelector(".events--wrap");
    ScrollTrigger.create({
      trigger: triggerEvent,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerEvent, className: "triggerEvents" },
      // markers: true,
    });

    //mobile tabs

    let triggerTabs = document.querySelector(".partron-2");
    ScrollTrigger.create({
      trigger: triggerTabs,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerTabs, className: "triggerPs" },
      // markers: true,
    });

    // mobile happenings
    let triggerHa = document.querySelector(".h_sectionT");
    ScrollTrigger.create({
      trigger: triggerHa,
      start: "top 70%",
      end: "bottom 0%",
      toggleClass: { targets: triggerHa, className: "triggerHa" },
      // markers: true,
    });
  }
}
